import { Component, ViewChild } from '@angular/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { DialogModule } from 'primeng/dialog';
import { HistoricoEventoService } from '../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom, forkJoin } from 'rxjs';
import { ISecCargoPermisoHistorico } from '../../../../shared/interfaces/database/seguridad';

@Component({
  selector: 'app-cargo-permiso-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle],
  template: `
  <section>
    <p-dialog [(visible)]="displayModal" [modal]="true" [autoZIndex]="true" [draggable]="false"
      [resizable]="true" [maximizable]="true" [breakpoints]="{'640px': '100vw'}" [style]="{width: '90vw'}">

      <ng-template pTemplate="header">
        <CustomTitle [title]="title" />
      </ng-template>

      <ng-template pTemplate="content">
        <custom-table [config]="customTable">
        </custom-table>
      </ng-template>

      <ng-template pTemplate="footer">			
      </ng-template>
    </p-dialog>
  </section>
  `
})
export class CargoPermisoHistoricoComponent {
  title: string = 'Cargo Permiso Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private _hes: HistoricoEventoService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate().then(() => {
      this.title = this.trans.titulo;
      this.configColumns();
    });
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      titulo: this._t.get('msg.cargoPermisoHistorial'),
      cargoNombre: this._t.get('common.cargo'),
      permisoNombre: this._t.get('common.permiso'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion')
    }));
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'cargoNombre',
          header: this.trans.cargoNombre,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'permisoNombre',
          header: this.trans.permisoNombre,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        }
      ]
    } as ICustomTable;
  }

  show(cargoId: number) {
    this.displayModal = true;
    this.loadHistorial(cargoId);
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(secCargoId: number) {
    this._hes.getSecCargoPermisoHistorico(secCargoId).subscribe({
      next: (data: ISecCargoPermisoHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}
